import React, {useState, useEffect, useRef} from 'react';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';

import {Form, Input, Select, Spin, DatePicker, Checkbox} from 'antd';
import {Modal, Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import * as actionsModal from 'src/setup/redux/modal/Actions';
import {requestPOST, requestGET, requestPUT, API_URL, FILE_URL} from 'src/utils/baseAPI';
import * as actionsGlobal from 'src/setup/redux/global/Actions';
import {useAuth} from 'src/app/modules/auth';
import {useIntl} from 'react-intl';

const FormItem = Form.Item;
const {Option} = Select;

const {TextArea} = Input;

const ModalItem = (props) => {
  const dispatch = useDispatch();
  const {token} = authHelper.getAuth();
  const {currentUser} = useAuth();
  const intl = useIntl();

  const currentBranch = useSelector((state) => state.global.currentBranch);

  const dataModal = useSelector((state) => state.modal.dataModal);
  const modalVisible = useSelector((state) => state.modal.modalVisible);
  const modalSettingConfig = useSelector((state) => state.modal.modalSettingConfig);
  const id = dataModal?.id ?? null;

  const [form] = Form.useForm();
  const [loadding, setLoadding] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const res = await requestGET(`api/v1/settingconfigs/${currentUser.id}`);
      if (res && res.data) {
        form.setFieldsValue(res.data);
      }
    };
    fetchData();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = () => {
    form.resetFields();
    /*  props.setDataModal(null);
    props.setModalVisible(false); */
    dispatch(actionsModal.setModalSettingConfig(false));
  };

  const onFinish = async () => {
    await form.validateFields();

    try {
      const formData = form.getFieldsValue(true);
      formData.userId = currentUser.id;
      const res = await requestPOST(`api/v1/settingconfigs/creatupdate`, formData);
      if (res) {
        toast.success(intl.formatMessage({id: 'LOG.UPDATESUCESSFUL'}));
        dispatch(actionsGlobal.setChooseBranch(false));
        handleCancel();
      } else {
        toast.error(intl.formatMessage({id: 'LOG.UPDATEFAILED'}));
      }
    } catch (errorInfo) {
      // console.log('Failed:', errorInfo);
    }
  };
  const normalizeInput = (value) => {
    if (!value) return value;
    return value.toUpperCase();
  };

  const types = [
    {name: 'Cấm vào', id: 0},
    {name: 'Cảnh báo', id: 1},
  ];

  const handleSynczk = async () => {
    const res = await requestPOST(`api/v1/backupdatas/sync`, {});
    if (res) {
      toast.success('Đồng bộ thành công!');
    }
  };
  return (
    <Modal
      show={modalSettingConfig}
      fullscreen={'lg-down'}
      size='lgßß'
      onExited={handleCancel}
      keyboard={true}
      scrollable={true}
      onEscapeKeyDown={handleCancel}
    >
      <Modal.Header className='bg-primary px-4 py-3'>
        <Modal.Title className='text-white'>
          {intl.formatMessage({id: 'MENU.SYSTEMCONFIG'})}
        </Modal.Title>
        <button
          type='button'
          className='btn-close btn-close-white'
          aria-label='Close'
          onClick={handleCancel}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <Spin spinning={loadding}>
          {!loadding && (
            <Form form={form} layout='vertical' /* initialValues={initData} */ autoComplete='off'>
              <div className='row'>
                <div className='col-xl-12 col-lg-12'>
                  <FormItem label='' name='shareData' valuePropName='checked'>
                    <Checkbox>
                      {intl.formatMessage({id: 'SYSTEMCONFIG.SHAREDACROSSBRANCHES'})}
                    </Checkbox>
                  </FormItem>
                </div>
                <div className='col-xl-12 col-lg-12'>
                  <FormItem label='' name='isPaymentOut' valuePropName='checked'>
                    <Checkbox>{intl.formatMessage({id: 'SYSTEMCONFIG.PAYENTRANCELANE'})}</Checkbox>
                  </FormItem>
                </div>

                <div className='col-xl-12 col-lg-12'>
                  <FormItem label='' name='isRegisterMultilVehicle' valuePropName='checked'>
                    <Checkbox>
                      {intl.formatMessage({id: 'SYSTEMCONFIG.REGISTERMULTIVEHICLES'})}
                    </Checkbox>
                  </FormItem>
                </div>
                <div className='col-xl-12 col-lg-12'>
                  <FormItem label='' name={['configs', 'isPricingDischarge']} valuePropName='checked'>
                    <Checkbox>Xả thẻ tính tiền</Checkbox>
                  </FormItem>
                </div>
                

                <div className='col-xl-12 col-lg-12'>
                  <Button className='btn-success btn-sm m-btn' onClick={handleSynczk}>
                    Đồng Bộ ZK
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Spin>
      </Modal.Body>
      <Modal.Footer className='bg-light px-4 py-2 align-items-center'>
        <div className='d-flex justify-content-center  align-items-center'>
          <Button className='btn-sm btn-primary rounded-1 p-2  ms-2' onClick={onFinish}>
            <i className='fa fa-save'></i>
            {intl.formatMessage({id: 'BTN.SAVE'})}
          </Button>
        </div>
        <div className='d-flex justify-content-center  align-items-center'>
          <Button className='btn-sm btn-secondary rounded-1 p-2  ms-2' onClick={handleCancel}>
            <i className='fa fa-times'></i>
            {intl.formatMessage({id: 'BTN.CANCEL'})}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalItem;
